import { TagManagerArgs } from 'react-gtm-module';
import getEnvVar from './utils/getEnvVar';

export const COPY = {
  AI_STUDY_TOOL: 'AI Study Tool',
  SEND: 'Send',
  INACCURATE_AI:
    "Don't share personal data and keep in mind that AI can be inaccurate. For more info, see our ",
  REPLY_OR_ASK_FOR_HELP: 'Reply or ask for help',
  YOU: 'You',
  SOMETHING_WENT_WRONG: 'Something went wrong!',
  CHECK_BACK_LATER: 'Please check back later',
  CHECK_ANSWER: 'Check answer',
  INCORRECT: 'Incorrect',
  CORRECT: 'Correct',
  APP_CRASHED: 'App crashed possibly due a runtime error. Please check stack trace',
  WELCOME: 'Welcome!',
  WELCOME_MESSAGE_ONE:
    'My goal is to help you master core concepts that you can put to use on tests.',
  WELCOME_MESSAGE_TWO: 'If you run into trouble, try requesting:',
  WELCOME_MESSAGE_THREE:
    'Let’s try some problems related to your current topic. I’ll ask questions so we can work through this step-by-step.',
  DEFINITIONS: 'Definitions',
  CONCEPT_EXPLANATION: 'Concept explanations',
  CLARIFYING_INFO: 'Clarifying info',
  READY: 'Ready',
  START_SESSION: 'Start session',
  NEXT: 'Next',
  READ_MORE: 'Read more',
  READ_LESS: 'Read less',
  FAQS: 'FAQs.',
  FEEDBACK_POSITIVE: 'Great! Want to share why you gave that a thumbs-up?',
  FEEDBACK_NEGATIVE: 'Sorry about that! What was wrong with that response?',
  FEEDBACK_POSITIVE_TITLE: 'Great!',
  FEEDBACK_POSITIVE_SUBTITLE: 'Want to share more?',
  FEEDBACK_NEGATIVE_TITLE: 'Sorry about that!',
  FEEDBACK_NEGATIVE_SUBTITLE: 'What was wrong with that response?',
  FEEDBACK_SELECT_OPTION: 'Please select an option to continue',
  FEEDBACK_THANKS: 'Thanks for the feedback!',
  NO_THANKS: 'No, thanks',
  SUBMIT: 'Submit',
  FEEDBACK_POSITIVE_PLACEHOLDER: 'Type your reason here...',
  FEEDBACK_NEGATIVE_PLACEHOLDER: 'Please explain...',
  IT_WASNT_RELEVANT: 'It wasn’t relevant',
  IT_WASNT_ACCURATE: 'It wasn’t accurate',
  IT_WAS_BIASED: 'It was biased',
  IT_WAS_UNSAFE: 'It was unsafe',
  SKIP: 'Skip',
  SKIP_IN_FUTURE: 'Skip this in the future.',
  LIVE_CHAT_NOT_AVAILABLE: 'Ask me anything',
  LIVE_CHAT_NOT_AVAILABLE_MESSAGE_LIMIT:
    "You've reached the live chat message limit. Please continue with the MCQs.",
  SUBSTRING_MESSAGE_REACHED:
    "That's it for this problem! Feel free to keep asking questions or end our chat by closing this window.",
  CHOOSE_LANGUAGE: "Choose the language you'd like to continue in.",
  FALLBACK_FLAG: '🏳️',
  CANCEL: 'Cancel',
  DEFAULT: '[default]',
  CONVERSATION_END:
    "That's it for this problem! Feel free to keep asking questions or end our chat by closing this window.",
};

export const ARIA_LABELS = {
  CONVERSATIONS: 'Conversations.',
  MESSAGE_FROM_TUTOR: 'Tutor says',
  MESSAGE_SENT: 'Message Sent.',
  LOADING: 'Loading page contents',
  POSITIVE_FEEDBACK: 'Positive feedback',
  NEGATIVE_FEEDBACK: 'Negative feedback',
  CLOSE_MODAL: 'Close Modal',
  CLOSE_ERROR: 'Close error',
  ERROR: 'Error:',
  MORE_IN_CHAT: 'More in chat',
};

export const BFF_ENDPOINTS = {
  START_CONVERSATION: '/api/conversation/start',
  SEND_CONVERSATION: '/api/conversation/send',
  MARK_FEEDBACK: '/api/post-feedback',
  SME_CONVERSATION: '/api/conversation/full',
  CHECK_EXERCISE: '/api/exercise',
  CHAT_ACTION: '/api/books/',
};

// TIMEOUTS
const FLASH_SCREEN_DELAY = Number(getEnvVar("REACT_APP_FLASH_SCREEN_DELAY", ''));
console.log('FLASH_SCREEN_DELAY', FLASH_SCREEN_DELAY);

export const TIMEOUTS = {
  FEEDBACK_MODAL_CLOSE: 1000,
  DELAY_SCREEN_RENDER: Number.isFinite(FLASH_SCREEN_DELAY) ? FLASH_SCREEN_DELAY : 1500,
  CONVERSATION_SCROLL_DELAY: 9000,
  AUTO_SCROLL_QUESTION_DELAY: 3000,
  FEEDBACK_FOCUS_DELAY: 500,
};

/**
 * Time to let a screen reader finish announcing a result before the next
 * question is revealed, at a rough reading pace of 55ms per character.
 */
export function getAnnouncementReadTime(text: string) {
  return Math.min(25000, Math.max(2500, text.length * 55));
}

export const LOCALSTORAGE_KEYS = {
  IS_RETURNING_USER: 'isReturningUser',
};

export const testIds = {
  conversationSection: 'conversation_section',
  spinner: 'spinner',
  promptInput: 'prompt_input',
  pinnedConversation: 'pinned_conversation',
  explanation_section: 'explanation_section',
  nudge_section: 'nudge_section',
  feedback_thumbs: 'feedback_thumbs',
  more_in_chat: 'more_in_chat',
};

export const ROUTES = {
  EXTERNAL: {
    FOOTER_FAQ:
      'https://www.pearson.com/privacy-center/resources/ai-frequently-asked-questions.html',
  },
};

export const GOOGLE_ANALYTICS = {
  KEY: process.env.REACT_APP_GA_KEY ?? '',
  CATEGORY: 'Tutor',
  EVENTS: {
    LAUNCH_EVENT: 'launched',
    CONVERSATION_STARTED_EVENT: 'conversation_started',
    SEND_EVENT: 'send_pressed',
    CHECK_ANSWER_EVENT: 'check_answer_pressed',
    CONVERSATION_CLOSED_EVENT: 'conversation_closed',
  },
};

// Constant GTM Config
export const GTMTagManagerArgs: TagManagerArgs = {
  gtmId: getEnvVar('REACT_APP_GTM_ID', ''),
  auth: getEnvVar('REACT_APP_GTM_AUTH', ''),
  preview: getEnvVar('REACT_APP_GTM_PREVIEW', ''),
};

export const GTM_CONSTANTS = {
  appId: 'MLMAITutor',
  typePI: 'PI',
  typeIES: 'IES',
  typePVS: 'PVS',
};
